export class Info {
  constructor() {
    this.img = null;
    this.title = null;
    this.type = null;
    this.description = null;
    this.technologies = null;
    this.role = null;
    this.url = null;
    this.github = null;
    this.gallery = null;
    this.index = 0;
  }
}